<template>
  <div
    class="timeline-event-marker-custom-wrapper"
    :class="{
      'is-late': isLate,
      'is-resolved': isResolved,
      'is-milestone': isMilestone,
      'is-critical': isCritical,
    }"
  >
    <span class="timeline-event-marker-custom border-circle">
      <i
        v-if="timelineItem instanceof ShipmentEvent && timelineItem.isMilestone"
        aria-hidden="true"
        class="pi"
        :class="{
          'pi-check': isResolved,
          'pi-exclamation-triangle': timelineItem.late,
        }"
      />
    </span>
  </div>
</template>

<script lang="ts" setup>
import type { PropType } from 'vue';
import { computed, toRefs } from 'vue';

import {
  ShipmentEvent,
  ShipmentEventSeverity,
  ShipmentServiceIncident,
  TenderRequest,
  TenderResponse,
  TenderResponseCode,
  TimelineItem,
} from '@/model';

const props = defineProps({
  timelineItem: {
    type: Object as PropType<TimelineItem>,
    default: () => new ShipmentEvent(),
  },
  requireBothDates: {
    type: Boolean,
    default: () => false,
  },
});
const { timelineItem, requireBothDates } = toRefs(props);

const isLate = computed(() => {
  if (timelineItem.value instanceof ShipmentEvent) {
    return (
      timelineItem.value.late ||
      timelineItem.value.severity !== ShipmentEventSeverity.NORMAL
    );
  } else if (timelineItem.value instanceof TenderResponse) {
    return (
      timelineItem.value.responseCode ===
      TenderResponseCode.RESERVATION_DECLINED
    );
  } else if (timelineItem.value instanceof ShipmentServiceIncident) {
    return timelineItem.value.incidentType;
  } else {
    return false;
  }
});

const isResolved = computed(() => {
  if (timelineItem.value instanceof ShipmentEvent) {
    return timelineItem.value.isResolved(requireBothDates.value);
  } else if (timelineItem.value instanceof TenderRequest) {
    return timelineItem.value.tenderMethod;
  } else if (timelineItem.value instanceof TenderResponse) {
    return (
      timelineItem.value.responseCode ===
      TenderResponseCode.RESERVATION_ACCEPTED
    );
  } else {
    return false;
  }
});

const isMilestone = computed(() => {
  return (
    timelineItem.value instanceof ShipmentEvent &&
    timelineItem.value.isMilestone
  );
});

const isCritical = computed(() => {
  return (
    timelineItem.value instanceof ShipmentServiceIncident &&
    timelineItem.value.severity === ShipmentEventSeverity.CRITICAL
  );
});
</script>
